import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useAPIResourceAction(url: string, fn: (...args: any[]) => Promise<any>) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: fn,
    onSettled: () => queryClient.invalidateQueries({ queryKey: [url] }),
  })
}
